import { ColorPickerField } from '../components/ColorPickerField';
import { IconField } from '../components/IconField';
import DocumentTitle from './DocumentTitle/DocumentTitle';

const titlePlugin: any = {
  Renderer: ({ data }: any) => (
    <DocumentTitle
      title={data?.title}
      documentLink={data?.documentLink}
      icon={data?.style?.icon}
      iconBackground={data?.style?.iconBackground}
      iconColor={data?.style?.iconColor}
      bgColor={data?.style?.bgColor}
      textColor={data?.style?.textColor}
      // titlePosition={data?.style?.titlePosition}
      // titleType={data?.style?.titleType}
      padding={data?.style?.padding}
    />
  ),
  id: 'pageTitlePlugin',
  title: 'Page Title',
  description: 'Title with a customizable icon',
  version: 1,
  controls: [
    {
      title: 'Default Config',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            title: {
              type: 'string',
              default: 'Title',
            },
            documentLink: {
              type: 'string',
              default: '',
            },
          },
          required: ['title'],
        },
      },
    },
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                icon: {
                  type: 'string',
                  default: 'Anchor 2',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'rgba(255, 255, 255, 1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,0.8)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,0.8)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
                bgColor: {
                  type: 'string',
                  default: 'rgba(255, 255, 255, 1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Background Color: ',
                  },
                },
                padding: {
                  type: 'number',
                  default: 10,
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default titlePlugin;
